"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Base type for a GATEWAY_CLIENT_REQUEST request.
 */
var BaseGatewayClientRequest = /** @class */ (function () {
    /**
     * Create a new BaseGatewayClientRequest instance
     *
     * @param sessionId  the gateway session identifier
     */
    function BaseGatewayClientRequest(sessionId) {
        this.sessionId = sessionId;
    }
    return BaseGatewayClientRequest;
}());
exports.BaseGatewayClientRequest = BaseGatewayClientRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/base-gateway-client-request.js
// module id = 124
// module chunks = 1